import { FaReact } from "react-icons/fa";
import {
  SiCss3,
  SiFirebase,
  SiHtml5,
  SiJavascript,
  SiSass,
  SiTypescript,
  SiRedux,
} from "react-icons/si";

export const skillsConfig = [
  {
    icon: <SiHtml5 />,
    text: "HTML",
    color: "rgb(240, 101, 41)",
  },
  {
    icon: <SiCss3 />,
    text: "CSS",
    color: "rgb(41, 101, 241)",
  },
  {
    icon: <SiJavascript />,
    text: "JavaScript",
    color: "rgb(245, 222, 25)",
  },
  {
    icon: <SiTypescript />,
    text: "TypeScript",
    color: "rgb(45, 121, 199)",
  },
  {
    icon: <FaReact />,
    text: "React.js",
    color: "rgb(124, 197, 217)",
  },
  {
    icon: <SiRedux />,
    text: "Redux",
    color: "rgb(118,74,188)",
  },
  {
    icon: <SiFirebase />,
    text: "Firebase",
    color: "rgb(246,130,13)",
  },
  {
    icon: <SiSass />,
    text: "Sass",
    color: "rgb(204, 102, 153)",
  },
];
